var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#959598",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.283 1.026l9.743 9.7a.6.6 0 0 1 0 .853.606.606 0 0 1-.856 0L.428 1.877a.6.6 0 0 1 0-.851.606.606 0 0 1 .855 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.428 10.727l9.742-9.701a.606.606 0 0 1 .856 0 .6.6 0 0 1 0 .851L1.283 11.58a.606.606 0 0 1-.855 0 .6.6 0 0 1 0-.852z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.e558d34258241c598971e89ff7ce3b78.svg";
export { ForwardRef as ReactComponent };